import React, {  useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import {    FavouriteIcon, NewBackArrowIconEventPage, NewNextArrowIconEventPage } from '../../utils/icons'; // adjust imports
import PropTypes from "prop-types";
import SkeletonLoder from "../../components/common/skeletonLoder";
import {Layout,SliderContainerV1, Container} from "../../components/UserDashboard/styles";
// import { TrendingItem } from "./styles";
// import LazyImage from "../../components/common/LazyImage/LazyImage";
// import { CardContainer } from "../../components/AdventureCategories/styles";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { NewVideoPlayer } from "../../components/MainEvents/RecommendEventVideos/styles";
import {ImageUrl} from "../../utils/constants";
import { Circle, CircleContainerNew, Tick  } from "../../components/Journeys/styles";
import Thumbnail from "../../components/Thumbnail";
import { RelatedCard, RelatedCardContainer } from "./styles";
import { toast } from "react-toastify";
import { fetchApi } from "../../utils/methods";
import { LikeUnlikeEducationPost } from "../../redux/constants/apiConstants";
import { useDispatch } from "react-redux";
import { getAdventuresByCategory } from "../../redux/actions";
// import { showSuccessToast } from "../../components/UserDashboard/ToastHelper";



const CommonWellnessCard = ({
  title = "Announcements",
  data = [],
  cardRender, 
  showArrows = true,
  showDots = false,
  CatgoryName="",
  loading = true, 
  CategoryType = "",
  GetWellnessDashboardData=()=>{},
  GetArticlesData=()=>{},
  CatgoryId="",
}) => {


  const dispatch = useDispatch();
  const location = useLocation();

  const fetchAdventuresByCategory = (categoryName) => {
    dispatch(getAdventuresByCategory(categoryName));
  };


  const slidesToShow = 3;
  window.console.log("-",CatgoryName);
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const totalPages = Math.max(1, Math.ceil(data.length / slidesToShow));
  const history = useHistory();
  const [widthFix, setWidthFix] = useState(false);


  useEffect(() => {
    window.setTimeout(() => setWidthFix(true), 100);
  }, []);



  //   const handleBeforeChange = (_, newIndex) => {
  //     // const page = Math.floor(newIndex + 1 ) / 3;
  //     window.console.log("newIndex",newIndex);
  //     setCurrentSlide(currentSlide + 1);
  //   };



  const goNext = () => {
    if (currentSlide < totalPages) {
      sliderRef.current?.slickNext();
      setCurrentSlide((prev) => prev + 1);
    }
  };
  
  const goPrev = () => {
    if (currentSlide > 1) {
      sliderRef.current?.slickPrev();
      setCurrentSlide((prev) => prev - 1);
    }
  };

  // const SuccessToast = (text,msg) => {
  //   showSuccessToast(text,msg);
  // }
  


  const onClickFavoriteRibbon = (type, typeId, likeStatus, favoriteStatus, featureType = 1) => {
    let obj =
     {
       "type": type === "fitness_video" ? "fitness" : type,
       "type_id": typeId,
       "like_status": likeStatus,
     }
    if (featureType === 0) {
      obj['favorite_status'] = favoriteStatus;
    }
    favouriteEducationPost(obj);
  }
  
  const favouriteEducationPost = async(obj)=>{
    try{
      const res = await fetchApi("/" + LikeUnlikeEducationPost, "POST", obj);
      if(res.status === 'success'){
        toast.success(res?.data?.[0]);
        // SuccessToast("Details Updated",res?.data?.[0]);
        const StringArray = location.pathname.split('/');
        fetchAdventuresByCategory(StringArray[(StringArray.length - 1)]);
        GetWellnessDashboardData && GetWellnessDashboardData();
        GetArticlesData && GetArticlesData(CatgoryId, CategoryType);
      }else{
        toast.error(res?.data?.[0])
      }

    }catch(error){
      window.console.log(error)
    }

  }


  const [onHover, setOnHover]=useState({});
  
  const onEnterMouse = (id) => {
    setOnHover(id)
  }

  const onLeaveMouse = () => {
    setOnHover(-1)
  };


  const handleRedirections = (video,CategoryType) => {
    if(video.type === "fitness_video" || CategoryType === "fitness_video")
    {
      history.push(`/education/videos-library/${video.id}`)
    }
    else if(video.type === "recipe" ||  CategoryType === "recipe")
    { 
      history.push(`/wellness-resources/recipe-details/${video.id}`)
    }
    else
    {
      history.push(`/wellness-resources/article-details/${video.id}`)
    }

  }
  
 

  const sliderSettings = {
    dots: showDots,
    infinite: false,
    speed: 300,
    slidesToShow,
    slidesToScroll: slidesToShow,
    arrows: false,
    draggable: true,
    adaptiveHeight: false,
    variableWidth: false,
    // beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1252,
        settings: { dots: showDots, infinite: false, slidesToShow: 3, arrows: true },
      },
      {
        breakpoint: 600,
        settings: { dots: showDots, infinite: false, slidesToShow: 3, arrows: true },
      },
    ],
  };





  if (loading)
  { return (
    <SkeletonLoder
      width={"1248px"}
      height={"450px"}
    />
  )}
 

  return (


    <Layout margin="20px 0 0 0" padding="0px">
      <div className="headingMain">
        <div  className="heading">
          {title}
        </div>

        { showArrows && totalPages > 1  && (
          <div className="arrows">
            {currentSlide > 1 ? (
              <div className="iconBackground" /*onClick={() => sliderRef.current?.slickPrev()}*/ onClick={goPrev}>
                {NewBackArrowIconEventPage("#DA6C74")}
              </div>
            ):null}
            <div className="text">
              {currentSlide}/{totalPages}
            </div>
            {currentSlide < totalPages  ? (
              <div className="iconBackground" /*onClick={() => sliderRef.current?.slickNext()}*/ onClick={goNext}>
                {NewNextArrowIconEventPage("#DA6C74")}
              </div>
            ):<div className="iconPlaceholder"></div>}
          </div>
        )}
      </div>

      <Container style={{border: "none",borderRadius:"8px",marginTop:"16px",height:"285px"}}>
        <SliderContainerV1 display="flex"
          // content="center" 
          content={data.length === 1 ? "flex-start" : "center"}
          marginValue="0">
          {widthFix && ( <Slider {...sliderSettings} ref={sliderRef}>
            {data.map((video, index) =>
              cardRender ? (
                cardRender(video, index) 
              ) : (
              
                <RelatedCardContainer key={index} isBorder={"0.75px solid #DCDCDC"}>
                  <RelatedCard 
                    onMouseEnter={() => onEnterMouse(video.id)}
                    onMouseLeave={() => onLeaveMouse()}
                  >
                    <NewVideoPlayer height={'218px'}>
                      <Thumbnail
                        style={{ cursor: 'default' }} 
                        src={`${ImageUrl}/${video?.image || video?.thumbnail_image || video?.recipe_image}`}
                        alt={'img'}
                        height={'218px'}
                      />
                    </NewVideoPlayer>
                    {onHover === video.id &&
                        <div className='educateImageBackground'
                          // onClick={()=>history.push(`/education/adventure/${CategoryType}/${video.id}`)}
                          onClick={()=> handleRedirections(video,CategoryType)}
                        >
                          <div className="getStarted">
                            {  (video.type || CategoryType) === "fitness_video" ?  ("Get Moving")  : (video.type || CategoryType) === "recipe" ?  ("Start Cooking") : ("Start Learning")}
                          </div>
                        </div>
                    }
                    <div className='details'>
                      <div className='name' title={video?.title || video?.video_title}>
                        {video.type === "recipe" || CategoryType === "recipe" ? video.recipe_name || video?.name || video?.title : video?.title || video?.video_title}
                      </div>
  
                      { (video.type || CategoryType) === "article" ?
                        <div className='left-col'>
                          <div title={video?.title || video?.video_title}>
                            <CircleContainerNew style={{ "marginLeft": "15px" }}>
                              <div className="flex">
                                <Circle borderColor="#DA6C74" checked={video?.view_status} width={'20px'} height={'20px'} borderWidth={'1px'}>
                                  <Tick checked={video?.view_status} width={'6px'} height={'11px'} left={'6px'} top={'3px'}/>
                                </Circle>
                              </div>
                              <div className="quiz">
                                {("Article")}
                              </div>
                            </CircleContainerNew> 
                          </div>
                          <div title={video?.title || video?.video_title}>
                            <CircleContainerNew style={{ "marginLeft": "15px"}}>
                              <div className="flex">
                                <Circle borderColor="#DA6C74" checked={video?.quiz_status} width={'20px'} height={'20px'} borderWidth={'1px'}>
                                  <Tick checked={video?.quiz_status} width={'6px'} height={'11px'} left={'6px'} top={'3px'}/>
                                </Circle>
                              </div>
                              <div className="quiz">
                                {("Quiz")}
                              </div>
                            </CircleContainerNew> 
                          </div>
                        </div>
                        :
                        <div className='left-col'>
                          <div title={video?.title}>
                            <CircleContainerNew style={{ "marginLeft": "15px",marginRight:'20px' }}>
                              <div className="flex">
                                <Circle borderColor="#DA6C74" checked={video?.view_status} width={'20px'} height={'20px'} borderWidth={'1px'}>
                                  <Tick checked={video?.view_status} width={'6px'} height={'11px'} left={'6px'} top={'3px'}/>
                                </Circle>
                              </div>
                              <div className="quiz">
                                {("Watched")}
                              </div>
                            </CircleContainerNew> 
                          </div>
                          <div style={{cursor:'pointer', display:'flex'}} title={video?.title} 
                            onClick={() => {
                              onClickFavoriteRibbon(
                                video.type || CategoryType,
                                video.id,
                                0,
                                (video?.favorite_status ) ? 0 : 1,
                                0
                              );
                            }}
                          >
                            {<FavouriteIcon fill={video?.favorite_status? "#DA6C74" : "none"}/>}
                          </div>
                        </div>}
                    </div>
                  </RelatedCard>
                </RelatedCardContainer>
              )
            )}
          </Slider>)}
        </SliderContainerV1>
      </Container>
    </Layout>
  );
};

CommonWellnessCard.propTypes =
{
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  cardRender: PropTypes.func,
  showArrows: PropTypes.bool,
  showDots: PropTypes.bool,
  myAnnouncementCard: PropTypes.bool,
  myActicityCard: PropTypes.bool,
  myFocusCard: PropTypes.bool,
  refreshAnnouncements: PropTypes.func,
  activeFocusKey: PropTypes.string,
  loading: PropTypes.bool,
  icon: PropTypes.node, 
  history:PropTypes.object,
  CatgoryName:PropTypes.string,
  CategoryType:PropTypes.string,
  GetWellnessDashboardData:PropTypes.func,
  GetArticlesData:PropTypes.func,
  CatgoryId:PropTypes.string,
}


export default CommonWellnessCard;





